"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltChunkDestination = void 0;
var tslib_1 = require("tslib");
var map_creator_1 = require("../../../../base-utils/map-creator");
var string_1 = require("@devexpress/utils/lib/utils/string");
var alt_chunk_info_1 = require("../../model/alt-chunk-info");
var destination_1 = require("../destination");
var alt_chunk_properties_destination_1 = require("./alt-chunk-properties-destination");
var AltChunkDestination = (function (_super) {
    tslib_1.__extends(AltChunkDestination, _super);
    function AltChunkDestination() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(AltChunkDestination.prototype, "elementHandlerTable", {
        get: function () {
            return AltChunkDestination.handlerTable;
        },
        enumerable: false,
        configurable: true
    });
    AltChunkDestination.prototype.processElementOpen = function (reader) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var id;
            return tslib_1.__generator(this, function (_a) {
                id = reader.getAttributeNS('id', this.data.constants.relsNamespaceConst);
                if (!string_1.StringUtils.isNullOrEmpty(id))
                    this.relId = id;
                return [2];
            });
        });
    };
    AltChunkDestination.prototype.processElementClose = function (_reader) {
        if (!string_1.StringUtils.isNullOrEmpty(this.relId)) {
            this.data.altChunkImporter.altChunkInfos.push(new alt_chunk_info_1.AltChunkInfo(this.relId, this.data.subDocumentInfo.positionImporter.currPosition, this.data.subDocument));
            this.data.subDocumentInfo.paragraphImporter.insertParagraph();
        }
    };
    AltChunkDestination.handlerTable = new map_creator_1.MapCreator()
        .add('altChunkPr', function (data) { return new alt_chunk_properties_destination_1.AltChunkPropertiesDestination(data); })
        .get();
    return AltChunkDestination;
}(destination_1.ElementDestination));
exports.AltChunkDestination = AltChunkDestination;
